// ─────────────────────────────────────────────────────────────────────────
//  MainPage.jsx — главная страница PLANIUM (новая редакция)
//
//  Структура:
//    1. Hero           — новый оффер «3 дня или бесплатно»
//    2. LogoStrip      — лента клиентов (Burger King, Rostic's, и т.д.)
//    3. Guarantee      — блок гарантии с огромной «3»
//    4. Process        — 4 шага работы
//    5. PriceCalculator — калькулятор на реальном прайсе
//    6. WhatIncluded   — конфигуратор слоёв отчёта (интерактив)
//    7. ForWhom        — табы для 4 сегментов ЦА
//    8. FAQ            — аккордеон из 12 вопросов
//    9. CTASection     — финальная форма
//
//  Каждый блок — отдельный файл в blocks/. Константы прайса — в shared/pricing.js.
//  Цвета, секция-обёртка и примитивы — в shared/ui.js.
// ─────────────────────────────────────────────────────────────────────────

import Hero from "../blocks/Hero";
import LogoStrip from "../blocks/LogoStrip";
import Guarantee from "../blocks/Guarantee";
import Process from "../blocks/Process";
import PriceCalculator from "../blocks/PriceCalculator";
import WhatIncluded from "../blocks/WhatIncluded";
import ForWhom from "../blocks/ForWhom";
import FAQ from "../blocks/FAQ";
import CTASection from "../blocks/CTASection";

export default function MainPage({ onShowOrder }) {
  return (
    <>
      <Hero onShowOrder={onShowOrder} />
      <LogoStrip />
      <Guarantee onShowOrder={onShowOrder} />
      <Process />
      <PriceCalculator />
      <WhatIncluded />
      <ForWhom onShowOrder={onShowOrder} />
      <FAQ />
      <CTASection />
    </>
  );
}